import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "hybrid-pdp-variant" */ './HybridPDP'));
